import { InputNumber } from 'antd';
import { Settings2 } from 'lucide-react';

import { AUDIENCE_MAX, DURATION_MAX, DURATION_MIN, PAGE_MAX, PAGE_MIN } from '../constants';

import styles from '../index.module.scss';

const DEFAULT_MANUAL_PAGES = 12;

function summaryText(settings) {
    const parts = [
        Number.isInteger(settings.pageCount) ? `${settings.pageCount} 页` : '自动规划页数',
    ];
    if (Number.isInteger(settings.durationMinutes))
        parts.push(`讲 ${settings.durationMinutes} 分钟`);
    if (settings.audience.trim()) parts.push(`面向${settings.audience.trim()}`);
    if (settings.generateNotes) parts.push('含演讲备注');
    return parts.join(' · ');
}

export default function SettingsPanel({ settings, onChange }) {
    const manualPages = Number.isInteger(settings.pageCount);

    return (
        <details className={styles.settings}>
            <summary>
                <Settings2 size={16} aria-hidden />
                <span className={styles.settingsTitle}>演示设置</span>
                <span className={styles.settingsSummary}>{summaryText(settings)}</span>
            </summary>
            <div className={styles.settingsGrid}>
                <div className={styles.field}>
                    <label htmlFor="ppt-audience">受众（可选）</label>
                    <input
                        id="ppt-audience"
                        className={styles.input}
                        value={settings.audience}
                        maxLength={AUDIENCE_MAX}
                        placeholder="如：答辩评审老师、课题组同学"
                        onChange={(event) => onChange({ audience: event.target.value })}
                    />
                    <small>只用来调整表达方式，不会当作事实写进内容</small>
                </div>

                <div className={styles.field}>
                    <label htmlFor="ppt-duration">演讲时长（可选）</label>
                    <div className={styles.inputSuffix}>
                        <InputNumber
                            id="ppt-duration"
                            min={DURATION_MIN}
                            max={DURATION_MAX}
                            precision={0}
                            value={settings.durationMinutes}
                            placeholder="不限"
                            onChange={(value) =>
                                onChange({
                                    durationMinutes: Number.isInteger(value) ? value : null,
                                })
                            }
                        />
                        <span>分钟</span>
                    </div>
                    <small>按讲述节奏调整每页信息量</small>
                </div>

                <div className={styles.field}>
                    <span className={styles.fieldLabel} id="ppt-pages-label">
                        页数
                    </span>
                    <div
                        className={styles.segmented}
                        role="radiogroup"
                        aria-labelledby="ppt-pages-label"
                    >
                        <button
                            type="button"
                            role="radio"
                            aria-checked={!manualPages}
                            onClick={() => onChange({ pageCount: null })}
                        >
                            自动规划
                        </button>
                        <button
                            type="button"
                            role="radio"
                            aria-checked={manualPages}
                            onClick={() =>
                                !manualPages && onChange({ pageCount: DEFAULT_MANUAL_PAGES })
                            }
                        >
                            指定页数
                        </button>
                    </div>
                    {manualPages ? (
                        <div className={styles.inputSuffix}>
                            <InputNumber
                                aria-label="总页数"
                                min={PAGE_MIN}
                                max={PAGE_MAX}
                                precision={0}
                                value={settings.pageCount}
                                onChange={(value) =>
                                    Number.isInteger(value) && onChange({ pageCount: value })
                                }
                            />
                            <span>
                                页（{PAGE_MIN}–{PAGE_MAX}）
                            </span>
                        </div>
                    ) : (
                        <small>根据资料多少自动决定页数</small>
                    )}
                </div>

                <div className={styles.field}>
                    <span className={styles.fieldLabel}>演讲备注</span>
                    <label className={styles.checkbox}>
                        <input
                            type="checkbox"
                            checked={settings.generateNotes}
                            onChange={(event) => onChange({ generateNotes: event.target.checked })}
                        />
                        <span>
                            为每页生成演讲稿
                            <small>写入 PPTX 的演讲者备注，PDF 中不显示</small>
                        </span>
                    </label>
                </div>
            </div>
        </details>
    );
}
